import React , {useEffect} from 'react';
import './Footer.css';
import Aos from 'aos';
import "aos/dist/aos.css";

const Footer = () => {

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);


  return (
    <div className="footer_section">

    <footer className="main_footer">

    <div className="container-mid">
    <div className="d-flex-c f-sp f-wrap footer_dics">

<div className="right_div mt-1  text-center" data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >
  <img src="/images/icons/logo-white.png" className='' alt="" />
  <h1 className="healine_footer mt-2"> جميع الحقوق محفوظة </h1>
</div>

<div className="left_div mt-1 " data-aos="fade-left" data-aos-delay="32" data-aos-easing="ease-in" data-aos-mirror="true" >
<h1 className="healine_footer mt-1"> تابعنا على مواقع التواصل </h1>

    <div className="d-flex-c f-sv footer_icons mt-2">

    <img src="/images/icons/footer-twitter.png" className='ob_pointer' onClick={() => openInNewTab('https://twitter.com/compass_tourist') } alt="" />

    <img src="/images/icons/footer-insta.png" className='ob_pointer' onClick={() => openInNewTab('https://www.instagram.com/tourist_compass_sa/') } alt="" />

   
    </div>

</div>

</div>
    </div>


    </footer>

    </div>
  )
}

export default Footer